/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const NewPage = defineMessages({
  title: {
    id: 'CatalogOpenApi.NewPage.title',
    defaultMessage: 'Build a custom extension'
  },
  subtitle: {
    id: 'CatalogOpenApi.NewPage.subtitle',
    defaultMessage:
      'Use OpenAPI to create a custom extension to other applications. Add features like starting support tickets, sending PDF files, or providing tailored information.'
  }
});

export const QuickSetup = defineMessages({
  title: {
    id: 'CatalogOpenApi.QuickSetup.title',
    defaultMessage: 'Set up {title}'
  }
});

export const IntroStepMessages = defineMessages({
  instructions: {
    id: 'CatalogOpenApi.IntroStepMessages.instructions',
    defaultMessage: 'How to add a custom extension to {productName}:'
  },
  authenticationStep: {
    id: 'CatalogOpenApi.IntroStepMessages.authenticationStep',
    defaultMessage:
      'Use your credentials to authenticate the access necessary to add your extension.'
  },
  mappingStep: {
    id: 'CatalogOpenApi.IntroStepMessages.mappingStep',
    defaultMessage:
      'Review the mapped variables table to ensure that the correct responses are available before adding the extension to your draft or live environment.'
  }
});
